import React from 'react';
import './SideBar.scss';


class SideBar extends React.Component {

    navigateTo(idSelector) {
        const element = document.querySelector(idSelector);

        // smooth scroll to element and align it at the bottom
        element.scrollIntoView({ behavior: 'smooth', block: 'center' });
    }

    calculateYearsWork() {
        return new Date().getFullYear() - 2010;
    }

    calculateAge() {
        return new Date().getFullYear() - (new Date() > new Date(new Date().getFullYear(), 2, 6) ? 1992 : 1993);
    }

    render() {
        return (
            <div className="side-bar">
                <img src="https://i.imgur.com/Ydw3hph.png" className="avatar" alt="avatar" />
                <h1>Deyvison Souto</h1>
                <h3><span className="icon home-icon" />Montreal, CA <span className="icon canada-flag" /></h3>
                <h3><span className="icon baby" />From Recife, BR <span className="icon brasil-flag" /></h3>
                <h5><span className="computer" />{this.calculateYearsWork()} Years as Software Engineer</h5>
                <h5><span className="human" />{this.calculateAge()} Years as Human Being</h5>
                <h5><span className="couple" />Married with the love of my life <span className="heart" /></h5>
                <span className="about" onClick={() => this.navigateTo('#about')}>About</span>
                <span className="experiences" onClick={() => this.navigateTo('#experiences')}>Experiences</span>
                <span className="education" onClick={() => this.navigateTo('#education')}>Education</span>
                <span className="skills" onClick={() => this.navigateTo('#skills')}>Skills</span>
            </div>
        );
    }
}

export default SideBar;